import { defaultAggProps } from "./index60.js";
import { getAdjacencyWeightMod } from "./index62.js";
import { getLineLengthWeightMod } from "./index63.js";
import { getNorthWeightMod } from "./index64.js";
import { getSiteBoundaryWeightMod } from "./index65.js";
import { getUnboundWeightMod } from "./index66.js";
import { LineV3toLine3, getLinesFromPolygon } from "@project-rouge/rg-three";
import seedrandom from "seedrandom";
const getThreadContext = (dataset, props) => {
	const minAboveEntrance = Math.min(...dataset.apartments.aboveEntrance.map((a) => a.size[0]));
	const smallestFlat = Math.min(...dataset.apartments.main.map((a) => a.size[0]));
	const { coreWithLifts, moduleDepth, cornerCore, corridorWidth, gridCellWidth, gap } = dataset.aggConfig;
	const minApartmentWidth = Math.min(...dataset.apartments.all.map((a) => a.size[0]));
	const maxApartmentDepth = dataset.aggConfig.maxApartmentDepth;
	const balconyDepth = maxApartmentDepth - moduleDepth;
	const facadeId = dataset.modulousIds.facadeId;
	const facadeData = facadeId ? dataset.rvData.find((d) => d.modulousId === facadeId) : void 0;
	const facadeWidth = (facadeData === null || facadeData === void 0 ? void 0 : facadeData.totalThickness) || 0;
	const edgeWeightMods = [getLineLengthWeightMod()];
	const avoidNorthFactor = (props === null || props === void 0 ? void 0 : props.aggZoneProps.avoidNorthFactor) ?? defaultAggProps.avoidNorthFactor;
	const avoidNorthRange = (props === null || props === void 0 ? void 0 : props.aggZoneProps.avoidNorthRange) ?? defaultAggProps.avoidNorthRange;
	let unboundWeightMod;
	let rng;
	if (props) {
		const plotEdges = getLinesFromPolygon(props.plotPoly).map(LineV3toLine3);
		const siteBoundaryModifier = getSiteBoundaryWeightMod({
			siteEdges: props.siteEdges,
			siteBoundaryFactor: props.aggZoneProps.siteBoundaryFactor
		});
		const northModifier = getNorthWeightMod({
			avoidNorthFactor,
			avoidNorthRange
		});
		const adjacencyWeightMod = getAdjacencyWeightMod({
			plotEdges,
			adjacencyFactor: props.aggZoneProps.adjacencyFactor
		});
		edgeWeightMods.push(siteBoundaryModifier, northModifier, adjacencyWeightMod);
		if (props.aggProps.unboundedTailor) {
			const unboundWeightMod$1 = getUnboundWeightMod({ plotEdges });
			edgeWeightMods.push(unboundWeightMod$1);
		}
		unboundWeightMod = !(props === null || props === void 0 ? void 0 : props.aggProps.unboundedTailor) ? void 0 : getUnboundWeightMod({
			plotEdges,
			siteBoundaryFactor: .5
		});
		if (props.aggZoneProps.skeletonTailorSeed !== void 0) rng = seedrandom(`${props.aggZoneProps.skeletonTailorSeed}`);
	}
	return {
		doubleLoadDepth: maxApartmentDepth * 2 + corridorWidth,
		singleLoadDepth: maxApartmentDepth + corridorWidth + facadeWidth,
		corridorDepth: corridorWidth,
		face2face: dataset.aggConfig.face2FaceSeparation - balconyDepth + facadeWidth,
		face2side: dataset.aggConfig.face2FaceSeparation,
		minApartmentWidth: minApartmentWidth + gap * 2,
		minLineBuilding: minAboveEntrance + gap + coreWithLifts.size[0] + facadeWidth * 2,
		minBranchLength: minAboveEntrance - balconyDepth + facadeWidth,
		min1CornerWing: minAboveEntrance + gap,
		min2CornerWing: minAboveEntrance + 2 * (gap + moduleDepth),
		singleSmallSide: corridorWidth * .5 + facadeWidth,
		singleBigSide: corridorWidth * .5 + maxApartmentDepth,
		canTurnMinSize: maxApartmentDepth * 2 + corridorWidth + smallestFlat + gap * 3,
		gridCellWidth,
		loadToCornerCoreWidth: maxApartmentDepth + corridorWidth + cornerCore.size[0],
		loadToCornerCoreDepth: maxApartmentDepth + corridorWidth + cornerCore.size[1],
		gap,
		facadeWidth,
		avoidNorthFactor,
		avoidNorthRange,
		unboundWeightMod,
		maxWingLength: (props === null || props === void 0 ? void 0 : props.aggZoneProps.maxLength) ?? defaultAggProps.maxWingLength,
		edgeWeightMods,
		floors: (props === null || props === void 0 ? void 0 : props.aggZoneProps.floors) ?? 0,
		rng
	};
};
export { getThreadContext };

//# sourceMappingURL=index67.js.map